module.exports = __webpack_public_path__ + "static/media/23_RamaonaLettkamp_webfinal.2264c07c.jpg";